import {
  AppBase,
  baseFromDoc,
  FirestoreBaseDoc,
  makeDocConverter,
} from '../../base/firestore-model-base'
import type { PendingSchoolAccountDoc } from './pending-school-account.modl'

/**
 * PendingSchoolAccountHistory（仮登録申請の変更履歴）
 *
 * `pending_school_accounts/{pendingSchoolAccountId}/history/{historyId}`
 */

export type PendingSchoolAccountHistoryDoc = FirestoreBaseDoc & {
  pending_school_account: PendingSchoolAccountDoc & { document_id?: string }
  updated_by_user_type: 'admin' | 'school'
  updated_by_user_id: string
  updated_by_name: string
  updated_by_user_document_path: string
  update_info?: string | null
}

export type PendingSchoolAccountHistoryEntity = AppBase & {
  pending_school_account: PendingSchoolAccountDoc & { document_id?: string }
  updated_by_user_type: 'admin' | 'school'
  updated_by_user_id: string
  updated_by_name: string
  updated_by_user_document_path: string
  update_info?: string | null
}

export const pendingSchoolAccountHistoryDocConverter = makeDocConverter<PendingSchoolAccountHistoryDoc>()

export function toPendingSchoolAccountHistoryEntity(
  id: string,
  doc: PendingSchoolAccountHistoryDoc,
  path: string,
): PendingSchoolAccountHistoryEntity {
  return {
    ...baseFromDoc(id, doc, path),
    pending_school_account: doc.pending_school_account,
    updated_by_user_type: doc.updated_by_user_type,
    updated_by_user_id: doc.updated_by_user_id,
    updated_by_name: doc.updated_by_name,
    updated_by_user_document_path: doc.updated_by_user_document_path,
    update_info: doc.update_info ?? null,
  }
}

